/* Component Dependencies */
var specialOffersTemplate = require('templates/specialOffers.hbs');
var AriesComponent = require('libs/aries-component');

AriesComponent.create({
  type: 'specialOffers',
  template: {
    'specialOffers': specialOffersTemplate
  }
});
